/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ButtonOptions } from './ButtonOptions';
import {
    ButtonOptionsFromJSON,
    ButtonOptionsFromJSONTyped,
    ButtonOptionsToJSON,
    ButtonOptionsToJSONTyped,
} from './ButtonOptions';
import type { ConditionUpdateRequest } from './ConditionUpdateRequest';
import {
    ConditionUpdateRequestFromJSON,
    ConditionUpdateRequestFromJSONTyped,
    ConditionUpdateRequestToJSON,
    ConditionUpdateRequestToJSONTyped,
} from './ConditionUpdateRequest';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';
import type { ActionUpdateRequest } from './ActionUpdateRequest';
import {
    ActionUpdateRequestFromJSON,
    ActionUpdateRequestFromJSONTyped,
    ActionUpdateRequestToJSON,
    ActionUpdateRequestToJSONTyped,
} from './ActionUpdateRequest';
import type { MultiButtonOptions } from './MultiButtonOptions';
import {
    MultiButtonOptionsFromJSON,
    MultiButtonOptionsFromJSONTyped,
    MultiButtonOptionsToJSON,
    MultiButtonOptionsToJSONTyped,
} from './MultiButtonOptions';

/**
 * 
 * @export
 * @interface ButtonCreateRequestV2
 */
export interface ButtonCreateRequestV2 {
    /**
     * The `Domain` this `Button` belongs to
     * @type {Domain}
     * @memberof ButtonCreateRequestV2
     */
    domain: Domain;
    /**
     * Whether this `Button` is active
     * @type {boolean}
     * @memberof ButtonCreateRequestV2
     */
    active: boolean;
    /**
     * The display name of this `Button`
     * @type {string}
     * @memberof ButtonCreateRequestV2
     */
    name: string;
    /**
     * The type of this `Button`
     * @type {string}
     * @memberof ButtonCreateRequestV2
     */
    type: ButtonCreateRequestV2TypeEnum;
    /**
     * Display options for this `Button` (size, placement, etc.)
     * @type {ButtonOptions}
     * @memberof ButtonCreateRequestV2
     */
    options: ButtonOptions;
    /**
     * Options specific to multi-button layouts, or null for single buttons
     * @type {MultiButtonOptions}
     * @memberof ButtonCreateRequestV2
     */
    multiButtonOptions?: MultiButtonOptions;
    /**
     * The list of `Action`s to associate with this `Button`
     * @type {Array<ActionUpdateRequest>}
     * @memberof ButtonCreateRequestV2
     */
    actions: Array<ActionUpdateRequest>;
    /**
     * The list of `Condition`s to associate with this `Button`
     * @type {Array<ConditionUpdateRequest>}
     * @memberof ButtonCreateRequestV2
     */
    conditions: Array<ConditionUpdateRequest>;
}


/**
 * @export
 */
export const ButtonCreateRequestV2TypeEnum = {
    Single: 'SINGLE',
    Multi: 'MULTI',
    Full: 'FULL',
    Dots: 'DOTS'
} as const;
export type ButtonCreateRequestV2TypeEnum = typeof ButtonCreateRequestV2TypeEnum[keyof typeof ButtonCreateRequestV2TypeEnum];


/**
 * Check if a given object implements the ButtonCreateRequestV2 interface.
 */
export function instanceOfButtonCreateRequestV2(value: object): value is ButtonCreateRequestV2 {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    return true;
}

export function ButtonCreateRequestV2FromJSON(json: any): ButtonCreateRequestV2 {
    return ButtonCreateRequestV2FromJSONTyped(json, false);
}

export function ButtonCreateRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ButtonCreateRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': DomainFromJSON(json['domain']),
        'active': json['active'],
        'name': json['name'],
        'type': json['type'],
        'options': ButtonOptionsFromJSON(json['options']),
        'multiButtonOptions': json['multiButtonOptions'] == null ? undefined : MultiButtonOptionsFromJSON(json['multiButtonOptions']),
        'actions': ((json['actions'] as Array<any>).map(ActionUpdateRequestFromJSON)),
        'conditions': ((json['conditions'] as Array<any>).map(ConditionUpdateRequestFromJSON)),
    };
}

export function ButtonCreateRequestV2ToJSON(json: any): ButtonCreateRequestV2 {
    return ButtonCreateRequestV2ToJSONTyped(json, false);
}

export function ButtonCreateRequestV2ToJSONTyped(value?: ButtonCreateRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': DomainToJSON(value['domain']),
        'active': value['active'],
        'name': value['name'],
        'type': value['type'],
        'options': ButtonOptionsToJSON(value['options']),
        'multiButtonOptions': MultiButtonOptionsToJSON(value['multiButtonOptions']),
        'actions': ((value['actions'] as Array<any>).map(ActionUpdateRequestToJSON)),
        'conditions': ((value['conditions'] as Array<any>).map(ConditionUpdateRequestToJSON)),
    };
}

